<template>
    <vue-select
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på kategori</em>
        </template>
    </vue-select>
</template>
<script>
import VueSelect from '@components/Wrappers/VueSelect';
import CategorySubRepository from '@services/repositories/Product/CategorySubRepository';

export default {
    name: 'CategorySubFilter',
    components: {
        VueSelect,
    },
    props: {
        categoryId: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            raw: [],
        };
    },
    created() {
        const client = new CategorySubRepository();
        client.getAll().then((res) => {
            this.raw = res.map((item) => ({
                id: item.SubCategoryID,
                label: item.SubCategoryName,
                main_category_id: item.MainCategoryID,
            }));
        });
    },
    computed: {
        options() {
            return this.raw.filter((item) => item.main_category_id === this.categoryId);
        },
    },
};
</script>
